/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Manager_User_CountInputs */

const en_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} user(s)`)
};

const fr_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} utilisateur(s)`)
};

const de_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Benutzer(n)`)
};

const it_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} utente(i)`)
};

const ru_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пользователь(и) ${i?.count}`)
};

const es_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} usuario(s)`)
};

const zh_cn2_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 用户`)
};

const ja_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ユーザー`)
};

const hi_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} उपयोगकर्ता(ओं)`)
};

const pt_pt2_team_manager_user_count = /** @type {(inputs: Team_Manager_User_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} usuário(s)`)
};

/**
* | output |
* | --- |
* | "{count} user(s)" |
*
* @param {Team_Manager_User_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_count = /** @type {((inputs: Team_Manager_User_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_user_count(inputs)
	if (locale === "de") return de_team_manager_user_count(inputs)
	if (locale === "it") return it_team_manager_user_count(inputs)
	if (locale === "ru") return ru_team_manager_user_count(inputs)
	if (locale === "es") return es_team_manager_user_count(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_user_count(inputs)
	if (locale === "ja") return ja_team_manager_user_count(inputs)
	if (locale === "hi") return hi_team_manager_user_count(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_user_count(inputs)
	return en_team_manager_user_count(inputs)
});